<template>
  <div class="content-wrapper p-0">
    <div class="content">
      <h4 class="mb-3"><i class="fas fa-robot mr-2"></i>AI Assistant</h4>
      <!-- Ruling D7: key by clinicUrl so the whole subtree (and future child
           sections added in Task 11/12) fully remounts when the chain admin
           switches clinic on this reused central route, instead of relying on
           each descendant to watch clinicUrl individually. -->
      <AiAssistantSettings :key="clinicUrl" :clinic-url="clinicUrl" />
    </div>
  </div>
</template>

<script>
import AiAssistantSettings from "@/components/mcp/AiAssistantSettings.vue";

// Chain clinics: /:clinicUrl/central/ai-assistant (spec §12.2), gated by mcp.setting.manage (C_LEVEL).
export default {
  name: "ClinicAiAssistant",
  components: { AiAssistantSettings },
  computed: {
    clinicUrl() {
      return this.$route.params.clinicUrl;
    },
  },
};
</script>
